/* ============================================================
   EFX Email Popup — frontend behavior
   ============================================================ */

(function() {
  'use strict';

  const STORAGE_KEY = 'efx_popup_dismissed_at';

  function init() {
    const popup = document.querySelector('[data-popup]');
    if (!popup) return;

    const delaySeconds = parseInt(popup.dataset.delaySeconds, 10) || 5;
    const reshowDays = parseInt(popup.dataset.reshowDays, 10) || 30;
    const endpoint = popup.dataset.endpoint || '';

    // Should we show?
    if (wasRecentlyDismissed(reshowDays)) return;

    // Trigger
    setTimeout(() => showPopup(popup), delaySeconds * 1000);

    // Close handlers
    popup.querySelectorAll('[data-popup-close]').forEach(el => {
      el.addEventListener('click', () => hidePopup(popup));
    });

    // Escape key closes
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hidden) hidePopup(popup);
    });

    // Form submit
    const form = popup.querySelector('[data-popup-form]');
    if (form) {
      form.addEventListener('submit', (e) => handleSubmit(e, popup, endpoint));
    }
  }

  function wasRecentlyDismissed(reshowDays) {
    try {
      const dismissedAt = localStorage.getItem(STORAGE_KEY);
      if (!dismissedAt) return false;
      const elapsed = Date.now() - parseInt(dismissedAt, 10);
      const reshowMs = reshowDays * 24 * 60 * 60 * 1000;
      return elapsed < reshowMs;
    } catch (e) {
      return false;
    }
  }

  function showPopup(popup) {
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function hidePopup(popup) {
    popup.hidden = true;
    document.body.style.overflow = '';
    try {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    } catch (e) {}
  }

  async function handleSubmit(e, popup, endpoint) {
    e.preventDefault();

    const form = e.currentTarget;
    const emailInput = form.querySelector('input[type="email"]');
    const submitBtn = form.querySelector('[data-popup-submit]');
    const submitLabel = submitBtn.querySelector('.efx-popup__submit-label');
    const submitSpinner = submitBtn.querySelector('.efx-popup__submit-spinner');
    const errorEl = form.querySelector('[data-popup-error]');

    const email = (emailInput.value || '').trim();

    // Basic email validation
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError(errorEl, 'Please enter a valid email address.');
      return;
    }

    if (!endpoint) {
      showError(errorEl, 'Configuration error: missing endpoint.');
      return;
    }

    // Loading state
    hideError(errorEl);
    submitBtn.disabled = true;
    submitLabel.hidden = true;
    submitSpinner.hidden = false;

    try {
      const discountPercent = parseInt(popup.dataset.discountPercent, 10) || 15;
      const daysValid = parseInt(popup.dataset.daysValid, 10) || 7;

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          discount_percent: discountPercent,
          days_valid: daysValid,
          source: 'email-popup',
        }),
      });

      if (!response.ok) {
        const errBody = await response.json().catch(() => ({}));
        throw new Error(errBody.error || `Server error (${response.status})`);
      }

      // Success — switch to success screen
      switchToSuccessScreen(popup);
    } catch (err) {
      showError(errorEl, err.message || 'Something went wrong. Please try again.');
      submitBtn.disabled = false;
      submitLabel.hidden = false;
      submitSpinner.hidden = true;
    }
  }

  function switchToSuccessScreen(popup) {
    const optinScreen = popup.querySelector('[data-screen="optin"]');
    const successScreen = popup.querySelector('[data-screen="success"]');
    if (optinScreen) optinScreen.hidden = true;
    if (successScreen) successScreen.hidden = false;
    // Mark as completed (won't show again)
    try {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    } catch (e) {}
  }

  function showError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function hideError(el) {
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  }

  // Init when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();